import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { API_URL } from "src/scenes/App";
import Information from "./components/Information";
import PurchaseLicense from "./components/PurchaseLicense";
import ClientLicenseModal from "./components/ClientLicenseModal";
import SendInviteFormModal from "src/components/AppInvite/SendInviteFormModal";

import SendRenewalForm from "./forms/SendRenewalForm";
import ClientLicenseTable from "./components/ClientLicenseTable";
import GetQRModal from "./components/GetQrModal";
import ClientDetailsForm from "./forms/ClientDetailsForm";
import UserFormSuccessModal from "../EmployeeList/components/UserFormSuccessModal";
import ClientLicenseBankDetailsForm from "./forms/ClientLicenseBankDetailsForm";
import SalesAndPromotionHeader from "./components/SalesAndPromotionHeader";
import { Toast, Text, PortalPageShell, portalColors } from "src/components";
import LoadingPage from "./components/LoadingPage";
import { ClientLicenseStatus } from "../LicenseRenewal/components/Constants";
import pluralize from "pluralize";
import { capitalizeString, customNames } from "src/utils/helpers";
import UserRoleAndPermissionsForm from "src/scenes/EmployeeList/components/UserRoleAndPermissionsForm";
import { NO_ROLE } from "src/constants/roles";

class ClientLicense extends Component {
    state = {
        fetching: 0,
        isSubscriptionExpired: false,
        unusedLicensesAvailable: 0, /** int | string = "Unlimited" */
        shortTermDurationUnit: "day",
        clientLicenseArray: [],
        enabledClientLicense: false,
        showPurchaseLicense: false,

        isShowEditForm: false,
        selectedLicenseEmployee: null,
        showSuccessModal: false,
        showClientForm: false,
        isClientFormEdit: false,
        clientFormData: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            clientType: "",
            licenseDuration: ""
        },
        isBankAccountDetailsEmpty: undefined,
        bankAccountDetails: {
            country: "",
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            swiftCode: "",
            bsbOrIban: "",
            invoiceOrStatementEmail: "",
            streetAddress: "",
            streetAddress2: "",
            city: "",
            state: "",
            addressCountry: "",
            postcodeOrZip: "",
        },
        showGetQrModal: false,
        isFreeTrialLicense: false,
        isZeroTrial: false,
        companyQrCode: null,
        earningPercent: 0,
        showSendInviteFormModal: false,
        inviteFormData: {
            users: []
        },
        isEmailSelected: true,
        isSmsSelected: false,
        licensesOverview: [],
        licenseTiers: [],
        roles: [],
        showUserPermissionsModal: false,
    };

    componentDidMount() {
        this.setState(state => ({
            fetching: state.fetching - 1
        }), () => {
            this.getCompanySubscriptionStatus();
            this.safeToInit();
        });
    }

    safeToInit = () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));
        this.getCompanyClientLicense();
        this.populateBankAccountDetailsForm();
        this.getLicenseOverview();
        this.getRolesAndDefaultPermissions();
    };

    getRolesAndDefaultPermissions = () => {
        axios.get(`${API_URL}/permissions/roles/get`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState({ roles: res.data.roles || [] });
        }).catch(error => {
            Toast.error(error.getApiErrorDetails().message);
        });
    };

    populateBankAccountDetailsForm = () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));

        axios.get(`${API_URL}/company/getBankAccountDetails`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            const bankAccount = res.data.bankAccountDetails;

            if (Array.isArray(bankAccount) && bankAccount.length === 0) {
                /* No record found */

                this.setState(({
                    isBankAccountDetailsEmpty: true
                }));
            }
            else { /* bankAccount - as Object */
                this.setState(prevState => ({
                    bankAccountDetails: {
                        country: bankAccount.countryCode,
                        accountHolderName: bankAccount.accountHolderName,
                        bankName: bankAccount.bankName,
                        accountNumber: bankAccount.accountNumber,
                        swiftCode: bankAccount.swiftCode,
                        bsbOrIban: bankAccount.bsbOrIban,
                        invoiceOrStatementEmail: bankAccount.email,
                        streetAddress: bankAccount.street,
                        streetAddress2: bankAccount.street2,
                        city: bankAccount.city,
                        state: bankAccount.state,
                        addressCountry: bankAccount.countryCodeAddress,
                        postcodeOrZip: bankAccount.postcodeOrZip,
                    },
                    isBankAccountDetailsEmpty: false
                }));
            }
        }).catch(error => {
            if (error.getApiErrorDetails().type === "network") {
                return Toast.error(error.getApiErrorDetails().message);
            }
        }).finally(error => {
            this.setState(state => ({
                fetching: state.fetching - 1
            }));
        });
    };

    getCompanySubscriptionStatus = () => {
        axios.get(`${API_URL}/company`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            const isSubscriptionValid = res.data.currentSubscription?.isExpired === false;
            this.setState({ isSubscriptionExpired: !isSubscriptionValid, licenseTiers: res.data.licenseTiers });
        })
            .catch(err => {
                return Toast.error(err.getApiErrorDetails().message);
            });
    };

    getCompanyClientLicense = async () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));

        return await axios.get(`${API_URL}/company/clientLicense`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.props.setEnabledClientLicenseFlag(true);
            this.setState(state => ({
                enabledClientLicense: this.props.user.enabledClientLicense,
            }));

            const unusedLicensesAvailable = res.data.unusedLicensesAvailable;
            const shortTermDurationUnit = res.data.shortTermDurationUnit;
            const isFreeTrialLicense = res.data.isFreeTrialLicense;
            const isZeroTrial = res.data.isZeroTrial;
            const companyQrCode = res.data.companyQrCode;
            const earningPercent = res.data.earningPercent;

            const allClients = res.data.clients;

            if (allClients) {
                allClients.forEach(element => {
                    if (element.startDate) {
                        const formatter = Intl.DateTimeFormat("default", { year: "numeric", month: "2-digit", day: "2-digit" });
                        const date = new Date(element.startDate);
                        element.startDate = formatter.format(date);
                    }

                    if (element.endDate) {
                        const formatter = Intl.DateTimeFormat("default", { year: "numeric", month: "long", day: "2-digit" });
                        const date = new Date(element.endDate);
                        const parts = formatter.formatToParts(date);

                        const day = parts.find(part => part.type === "day").value;
                        const month = parts.find(part => part.type === "month").value;
                        const year = parts.find(part => part.type === "year").value;

                        const formattedDate = `${day} ${month} ${year}`;
                        element.endDate = formattedDate;
                    }
                });
            }

            this.setState(state => ({
                unusedLicensesAvailable: isFreeTrialLicense ? "Unlimited" : Math.max(0, unusedLicensesAvailable),
                shortTermDurationUnit: shortTermDurationUnit,
                clientLicenseArray: allClients,
                isFreeTrialLicense: isFreeTrialLicense,
                isZeroTrial: isZeroTrial,
                companyQrCode: companyQrCode,
                earningPercent: earningPercent
            }));
        }).catch(error => {
            this.props.setEnabledClientLicenseFlag(false);
            this.setState(state => ({
                enabledClientLicense: this.props.user.enabledClientLicense,
            }));

            if (error.getStatus() !== 403) {
                return Toast.error(error.getApiErrorDetails().message);
            }
        }).finally(() => {
            this.setState(state => ({
                fetching: state.fetching - 1,
            }));
        });
    };

    getLicenseOverview = async () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));

        return await axios.get(`${API_URL}/company/clientLicense/licensesOverview`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState(state => ({
                licensesOverview: res.data.licensesOverview,
            }));
        }).catch(error => {
            this.props.setEnabledClientLicenseFlag(false);
            this.setState(state => ({
                enabledClientLicense: this.props.user.enabledClientLicense,
            }));

            if (error.getStatus() !== 403) {
                return Toast.error(error.getApiErrorDetails().message);
            }
        }).finally(() => {
            this.setState(state => ({
                fetching: state.fetching - 1,
            }));
        });
    };

    showPurchaseLicense = (bool) => {
        if (!this.state.isSubscriptionExpired) {
            this.setState({
                showPurchaseLicense: bool,
                enabledClientLicense: !bool
            });
        }
        else {
            return Toast.error("Please renew your subscription before purchasing more licenses.");
        }
    };

    sendInvite = (licenseEmployee) => {
        this.setState(prevState => ({
            selectedLicenseEmployee: licenseEmployee
        }), () => this.openSendInviteForm(licenseEmployee));
    };

    openSendInviteForm = (data) => {
        //from LicenseEmployee to Employee
        const employeesObject = data.map((user) => {
            return {
                uuid: user.employeeUuid,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                phoneNumber: user.phoneNumber
            };
        });

        this.setState({
            inviteFormData: {
                users: employeesObject
            },
            showSendInviteFormModal: true,
            showSuccessModal: false,
        });
    };

    handleCloseInviteFormModal = reload => {
        this.setState({ showSendInviteFormModal: false });
        if (reload) {
            this.getCompanyClientLicense();
            this.getLicenseOverview();
        }
    };

    sendRenewalLink = (licenseEmployee) => {
        this.setState(prevState => ({
            selectedLicenseEmployee: licenseEmployee
        }), () => this.sendRenewalModal());
    };

    checkEmailInvite = () => {
        this.setState({
            isEmailSelected: !this.state.isEmailSelected
        });
    };

    checkSmsInvite = () => {
        this.setState({
            isSmsSelected: !this.state.isSmsSelected
        });
    };

    setAppInviteMethod = (method) => {
        this.setState({
            isEmailSelected: method === "email" || method === "both",
            isSmsSelected: method === "sms" || method === "both",
        });
    };

    sendRenewalModal = () => {
        const modalHeader = <>Send License Renewal Link</>;
        const sendRenewalForm = <>
            <SendRenewalForm
                user={this.props.user}
                selectedLicenseEmployee={this.state.selectedLicenseEmployee}
                getCompanyClientLicense={this.getCompanyClientLicense}
                isEmailSelected={this.state.isEmailSelected}
                isSmsSelected={this.state.isSmsSelected}
                checkEmailInvite={this.checkEmailInvite}
                checkSmsInvite={this.checkSmsInvite}
                setAppInviteMethod={this.setAppInviteMethod}
            />

        </>;
        return ClientLicenseModal.open(
            modalHeader,
            sendRenewalForm,
            false
        );
    };

    handleShowGetQrModal = () => {
        if (!this.state.companyQrCode || this.state.companyQrCode.length === 0) {
            return Toast.error("QR Code is not yet implemented to this company");
        }

        this.setState({
            showGetQrModal: true,
        });
    };

    handleCloseGetQrModal = () => {
        this.setState({
            showGetQrModal: false,
        });
    };

    addClient = () => {
        this.setState({
            showClientForm: true,
            isClientFormEdit: false,
            clientFormData: {
                uuid: "",
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                clientType: "",
                licenseDuration: ""
            }
        });
    };

    updateClient = (licenseEmployee) => {
        this.setState((prevState) => ({
            clientFormData: {
                ...prevState.clientFormData,
                uuid: licenseEmployee.employeeUuid,
                firstName: licenseEmployee.firstName,
                lastName: licenseEmployee.lastName,
                email: licenseEmployee.email,
                phoneNumber: licenseEmployee.phoneNumber,
                clientType: licenseEmployee.clientType,
                licenseDuration: licenseEmployee.licenseType
            },
            showClientForm: true,
            isClientFormEdit: true
        }));
    };

    handleCloseSuccessModal = () => {
        this.setState({
            enabledClientLicense: false,
            showSuccessModal: false,
            clientFormData: {
                uuid: "",
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                clientType: "",
                licenseDuration: ""
            }
        }, () => {
            this.getCompanyClientLicense();
            this.getLicenseOverview();
        });
    };

    enableSuccessModal = (data) => {
        this.setState({
            showSuccessModal: true,
            showClientForm: false,
            clientFormData: data
        });
    };

    refreshTableOnClientDelete = () => {
        this.setState({
            enabledClientLicense: false,
            showClientForm: false
        }, () => {
            this.getCompanyClientLicense();
            this.getLicenseOverview();
        });
    };

    refreshTableOnClientSetPermission = () => {
        this.getCompanyClientLicense();
        this.getLicenseOverview();
    };

    openUserPermissionsModal = () => {
        this.setState({ showUserPermissionsModal: true });
    };

    closeUserPermissionsModal = () => {
        this.setState({ showUserPermissionsModal: false });
    };

    handleUserPermissionsSaved = () => {
        this.refreshTableOnClientSetPermission();
        this.closeUserPermissionsModal();
    };

    getPermissionModalClients = () => this.state.clientLicenseArray.map(client => ({
        ...client,
        uuid: client.employeeUuid || client.uuid,
        department: client.customCompanyName || client.employmentPosition || ""
    }));

    renderModalTitle = () => {
        return <div style={{ display: "flex", justifyContent: "center", margin: "0rem 0 2rem 0" }}>
            <Text color="#11141A" weight="700" size="2.5rem" align="center"
                width="100%" maxWidth="22.875rem"
            >
                {this.state.isClientFormEdit ? `Trial ${capitalizeString(pluralize.singular(customNames.clients))} Updated Successfully!` : `New Trial ${capitalizeString(pluralize.singular(customNames.clients))}  Added Successfully!`}
            </Text>
        </div>;
    };

    render() {
        const {
            fetching,
            clientLicenseArray,
            enabledClientLicense,
            showPurchaseLicense,
            unusedLicensesAvailable,
            shortTermDurationUnit,
            showClientForm,
            clientFormData,
            showSuccessModal,
            isClientFormEdit,
            isBankAccountDetailsEmpty,
            bankAccountDetails,
            showGetQrModal,
            isFreeTrialLicense,
            companyQrCode,
            earningPercent,
            showSendInviteFormModal,
            inviteFormData,
            licensesOverview,
            isZeroTrial,
            licenseTiers,
            roles,
            showUserPermissionsModal
        } = this.state;

        const { user } = this.props;

        if (fetching > 0) {
            return <LoadingPage user={user} />;
        }

        return (
            <>
                {showPurchaseLicense && (
                    <PurchaseLicense
                        user={user}
                        showPurchaseLicense={this.showPurchaseLicense}
                        shortTermDurationUnit={shortTermDurationUnit}
                        getCompanyClientLicense={this.getCompanyClientLicense}
                    />
                )}

                {enabledClientLicense && (
                    <BankDetailsAndSalesAndPromotionsTable
                        user={user}
                        addClient={this.addClient}
                        updateClient={this.updateClient}
                        unusedLicensesAvailable={unusedLicensesAvailable}
                        clientLicenseArray={clientLicenseArray}
                        showPurchaseLicense={this.showPurchaseLicense}
                        sendInvite={this.sendInvite}
                        editLicense={this.editLicense}
                        sendRenewalLink={this.sendRenewalLink}
                        isBankAccountDetailsEmpty={isBankAccountDetailsEmpty}
                        isRenewalEarningPercentGreaterThanZero={earningPercent > 0}
                        bankAccountDetails={bankAccountDetails}
                        handleShowGetQrModal={this.handleShowGetQrModal}
                        isFreeTrialLicense={isFreeTrialLicense}
                        licensesOverview={licensesOverview}
                        refreshTableOnClientSetPermission={this.refreshTableOnClientSetPermission}
                        licenseTiers={licenseTiers}
                        openUserPermissionsModal={this.openUserPermissionsModal}
                    />
                )}
                {showUserPermissionsModal && (
                    <UserRoleAndPermissionsForm
                        user={user}
                        showDialog={showUserPermissionsModal}
                        handleClose={this.closeUserPermissionsModal}
                        onFormSubmissionSuccessful={this.handleUserPermissionsSaved}
                        userUuid={null}
                        userName={null}
                        userEmail={null}
                        userRole={NO_ROLE}
                        userPermissions={[]}
                        roles={roles}
                        token={user.token}
                        isClient={true}
                        isBulk={true}
                        users={this.getPermissionModalClients()}
                        customNames={customNames}
                        hasLeadershipRole={false}
                        permissionSource="sales"
                        lockBulkUserType
                    />
                )}
                {showClientForm && (
                    <ClientDetailsForm
                        enableSuccessModal={(data) => this.enableSuccessModal(data)}
                        refreshTableOnClientDelete={this.refreshTableOnClientDelete}
                        client={clientFormData}
                        showDialog={showClientForm}
                        shortTermDurationUnit={shortTermDurationUnit}
                        handleClose={() => this.setState({ showClientForm: false })}
                        isClientFormEdit={isClientFormEdit}
                        token={user.token}
                        countryCode={user.countryCode}
                        isZeroTrial={isZeroTrial}
                        isFreeTrialLicense={isFreeTrialLicense}
                        onTrialClientConverted={this.refreshTableOnClientSetPermission}
                    />
                )}
                {showSuccessModal && (
                    <UserFormSuccessModal
                        showDialog={showSuccessModal}
                        handleClose={() => this.handleCloseSuccessModal()}
                        user={clientFormData}
                        title={this.renderModalTitle()}
                        isUserNewlyCreated={!isClientFormEdit}
                        openSendInviteForm={this.openSendInviteForm}

                    />
                )}
                {showGetQrModal && (
                    <GetQRModal
                        showGetQrModal={showGetQrModal}
                        handleCloseGetQrModal={this.handleCloseGetQrModal}
                        companyQrCode={companyQrCode}
                    />
                )}

                {showSendInviteFormModal && <>
                    <SendInviteFormModal
                        showDialog={showSendInviteFormModal}
                        handleClose={reload => this.handleCloseInviteFormModal(reload)}
                        users={inviteFormData.users}
                        token={user.token}
                    />
                </>}

                {!fetching && !showPurchaseLicense && !enabledClientLicense && !showClientForm && (
                    <Information user={user} />
                )}

            </>
        );
    }
}

const BankDetailsAndSalesAndPromotionsTable = (props) => {
    const [isShowGetStarted, setIsShowGetStarted] = useState(props.isBankAccountDetailsEmpty && props.isRenewalEarningPercentGreaterThanZero);
    const [filter, setFilter] = useState(ClientLicenseStatus.ALL_STATUSES);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const filteredClientLicenseArray = props.clientLicenseArray.filter(item => {
        if (filter === ClientLicenseStatus.ALL_STATUSES) return true;
        return item.licenseStatus === filter;
    });

    return (
        <PortalPageShell>

            <SalesAndPromotionHeader
                unusedLicensesAvailable={props.unusedLicensesAvailable}
                handleShowGetQrModal={props.handleShowGetQrModal}
                isFreeTrialLicense={props.isFreeTrialLicense}
                onFilterChange={onFilterChange}
                licensesOverview={props.licensesOverview}
                user={props.user}
                licenseTiers={props.licenseTiers}
                openUserPermissionsModal={props.openUserPermissionsModal}
            />

            {isShowGetStarted && <BankDetailsContainer
                user={props.user}
                bankAccountDetails={props.bankAccountDetails}
                setIsShowGetStarted={setIsShowGetStarted}
            />
            }
            {!isShowGetStarted && <ClientLicenseTable
                user={props.user}
                addClient={props.addClient}
                updateClient={props.updateClient}

                clientLicenseArray={filteredClientLicenseArray}
                showPurchaseLicense={props.showPurchaseLicense}
                sendInvite={props.sendInvite}
                editLicense={props.editLicense}
                sendRenewalLink={props.sendRenewalLink}
                isBankAccountDetailsEmpty={props.isBankAccountDetailsEmpty}
                bankAccountDetails={props.bankAccountDetails}
                isFreeTrialLicense={props.isFreeTrialLicense}
                filter={filter}
                refreshTableOnClientSetPermission={props.refreshTableOnClientSetPermission}
                licenseTiers={props.licenseTiers}
                openUserPermissionsModal={props.openUserPermissionsModal}
            />

            }
        </PortalPageShell>
    );
};

const BankDetailsShell = styled.div`
    width: 100%;
    max-width: 98.625rem;
    padding: 1rem;
    box-sizing: border-box;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    box-shadow: ${portalColors.shadow};

    @media (max-width: 760px) {
        padding: 0.85rem;
    }
`;

function BankDetailsContainer(props) {
    const { user, bankAccountDetails, setIsShowGetStarted } = props;
    return (
        <BankDetailsShell>
            <ClientLicenseBankDetailsForm token={user.token} bankAccountDetails={bankAccountDetails} setIsShowGetStarted={setIsShowGetStarted} />
        </BankDetailsShell>
    );
}

export default withRouter(ClientLicense);
